// ==============================================
// ===================Imports====================
// ==============================================
// ==============================================

// =================ACTIONS=====================
import {
  LAUNCH_DATA_PAGINATION,
  SAVE_FILES_DATA,
  SAVE_FILES_DATA_PAGINATION,
  SAVE_FILES_GRID,
  SAVE_LOCATION_FILE,
  SET_FILE_CLICKED,
  SET_LOADING_FILES,
  SET_MARKER_FILES_STRING,
  SET_OPEN_MODAL,
  SET_PAGE_VALUE,
  SET_SAVE_FILES_SELECTED,
  SET_SAVE_FILES_SELECTED_PAGE_FILE,
  SET_SAVE_QUERY_PARAMS,
  SET_VALUE_DISPLAY_LOADING,
} from '../actions/file';

// ==============================================
// ================InitialState==================
// ==============================================

const initialState = {
  displayLoading: false,
  numberPerPage: 5000,
  dataPagination: false,
  page: 1,
  location: '',
  loadingFiles: true,
  dataFiles: [],
  dataFilePagination: [],
  filesGrid: [],
  pageFileSelected: [],
  grid: {
    filesSelected: [],
  },
  modal: {
    openModal: false,
  },
  markerFilesString: '',
  fileClicked: '',
  queryParams: '',
};

function filesReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SAVE_FILES_DATA:
      return {
        ...state,
        dataFiles: action.value,
      };
    case SAVE_FILES_GRID:
      return {
        ...state,
        filesGrid: action.value,
      };
    case SET_OPEN_MODAL:
      return {
        ...state,
        modal: {
          ...state.modal,
          openModal: action.value,
        },
      };
    case SET_SAVE_FILES_SELECTED:
      return {
        ...state,
        grid: {
          ...state.grid,
          filesSelected: action.value,
        },
      };
    case SET_SAVE_FILES_SELECTED_PAGE_FILE:
      return {
        ...state,
        pageFileSelected: action.value,
      };
    case SET_MARKER_FILES_STRING:
      return {
        ...state,
        markerFilesString: action.value,
      };
    case SET_LOADING_FILES:
      return {
        ...state,
        loadingFiles: action.value,
      };
    case SAVE_LOCATION_FILE:
      return {
        ...state,
        location: action.value,
      };
    case SET_FILE_CLICKED:
      return {
        ...state,
        fileClicked: action.value,
      };
    case SET_PAGE_VALUE:
      return {
        ...state,
        page: action.value,
      };
    case SAVE_FILES_DATA_PAGINATION:
      return {
        ...state,
        dataFilePagination: action.value,
      };
    case LAUNCH_DATA_PAGINATION:
      return {
        ...state,
        dataPagination: action.value,
      };
    case SET_VALUE_DISPLAY_LOADING:
      return {
        ...state,
        displayLoading: action.value,
      };
    case SET_SAVE_QUERY_PARAMS:
      return {
        ...state,
        queryParams: action.value,
      };
    default:
      return state;
  }
}

export default filesReducer;
